import { apiV2 } from "../v2";
import { listAdminImagesRequest, listAdminImagesResponse, updateAdminImageRequest, updateAdminImageResponse } from "./images.dto";

/** Unused stock images of one keyword, newest first within the keyword. */
export const listAdminImagesApi = apiV2("GET", "/admin/images").withRequest(listAdminImagesRequest).withResponse(listAdminImagesResponse);

export const updateAdminImageApi = apiV2("PATCH", "/admin/images/:id").withRequest(updateAdminImageRequest).withResponse(updateAdminImageResponse);
